/**
 * [CUSTOM FILE] — not part of Stretch base theme
 * collection-image-mode.js
 * ------------------------
 * Drives the "Model" checkbox toggle in the collection toolbar.
 * Checked = model mode, unchecked = flat mode (default).
 * State persisted in localStorage across pagination and navigation.
 */

const IMAGE_MODE_KEY = 'collection_image_mode';

class CollectionImageModeButton extends HTMLElement {
  connectedCallback() {
    this._checkbox = this.querySelector('input[type="checkbox"]');
    if (!this._checkbox) return;

    // Restore persisted state
    const saved = localStorage.getItem(IMAGE_MODE_KEY);
    if (saved === 'model') {
      this._checkbox.checked = true;
      this._applyMode('model');
    }

    this._checkbox.addEventListener('change', () => {
      const mode = this._checkbox.checked ? 'model' : 'flat';
      localStorage.setItem(IMAGE_MODE_KEY, mode);
      this._applyMode(mode);
      // Sync the other breakpoint's checkbox
      document.querySelectorAll('collection-image-mode-button input[type="checkbox"]').forEach((cb) => {
        cb.checked = this._checkbox.checked;
      });
    });
  }

  _applyMode(value) {
    const productList = document.querySelector('.collection product-list') || document.querySelector('product-list');
    if (productList) productList.setAttribute('image-mode', value);
  }
}

if (!window.customElements.get('collection-image-mode-button')) {
  window.customElements.define('collection-image-mode-button', CollectionImageModeButton);
}
